import { render, staticRenderFns } from "./CourseOutcomesForm.vue?vue&type=template&id=48e7b926"
import script from "./CourseOutcomesForm.vue?vue&type=script&lang=js"
export * from "./CourseOutcomesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports